import { timeZone } from 'interfaces/timezone-type';
import { BookingFilterAny } from 'stores/rematch/models/types/booking-filter';
import { TimezoneSelectorMode } from 'utilities/enum-utils';
import { IRosterBooking, IRosterShift } from '../bookings-roster-view/types';
import { ROSTER_TAB } from '../bookings-roster-view/components/roster-common-enums';
import { Updater } from '@tanstack/react-table';
import { BookingsViewType } from '../booking-view-toolbar/types';

export const noop = () => {};
export const asyncNoop = async () => Promise.resolve();

export type BookingDrawerContentType = 'customerBooking' | 'openSlot' | 'workerShift';

export type RosterPeriodView = 'daily' | 'weekly';

export type OnSelectRosterItemOptions = {
  item: IRosterBooking | IRosterShift | null;
  type: BookingDrawerContentType | null;
  tab: ROSTER_TAB | null;
};

export type BookingsViewContextType = {
  displayTimezone: timeZone | null | undefined;
  drawerOpened: boolean;
  onChangeFilter: (filters: BookingFilterAny[]) => void;
  onChangeRosterPeriod: (period: RosterPeriodView) => void;
  onChangeTimezone: (type: 'mode' | 'customTimezone', value: TimezoneSelectorMode) => void;
  onDeselectRosterItem: () => void;
  onOpenCreateBooking: (opts?: { customer?: unknown; startDate?: Date }) => void;
  onSelectRosterItem: (next: Updater<OnSelectRosterItemOptions> | OnSelectRosterItemOptions) => void;
  refreshListings: () => void;
  registerRefetchRoster: (refetch: () => Promise<void>) => void;
  retry: () => Promise<void>;
  rosterPeriod: RosterPeriodView;
  selectedRosterItem: IRosterBooking | IRosterShift | null;
  view: BookingsViewType;
};

export const bookingsViewContextInitialState: BookingsViewContextType = {
  displayTimezone: undefined,
  drawerOpened: false,
  onChangeFilter: noop,
  onChangeRosterPeriod: noop,
  onChangeTimezone: noop,
  onDeselectRosterItem: noop,
  onOpenCreateBooking: noop,
  onSelectRosterItem: noop,
  refreshListings: noop,
  registerRefetchRoster: noop,
  retry: asyncNoop,
  rosterPeriod: 'weekly',
  selectedRosterItem: null,
  view: 'list',
};
